import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  isCallAssetListAPI: false,
  showNotificationPopper: null,
  partnerRouteLink: null,
  showLoginPopper: false,
  showOptionPopper: null,
  showLogin360Popper: null,
  showSignup360Popper: null,
  showGuest360Popper: null,
  showNotLoginPopper: null,
  showSignupPopper: null,
  guestId: "",
  currentUser: null,
  showOrganizationPopper: null,
  showProfilePopper: null,
  showOrgModal: false,
  showUserVerifyStatusModal: false,
  showSignupModal: false,
  showLoginModal: false,
  showGuestSignupModal: false,
  isOnAssetPage: false,
  isShowTNCDialog: false,
  loginAction: null,
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState: initialWorkersState,
  reducers: {
    setCallAssetListAPI: (state, action) => {
      state.isCallAssetListAPI = action.payload;
    },

    setShowNotificationPopper: (state, action) => {
      state.showNotificationPopper = action.payload;
    },
    setPartnerRouteLink: (state, action) => {
      state.partnerRouteLink = action.payload;
    },
    setShowLoginPopper: (state, action) => {
      state.showLoginPopper = action.payload;
    },
    setShowOptionPopper: (state, action) => {
      state.showOptionPopper = action.payload;
    },
    setShowLogin360Popper: (state, action) => {
      state.showLogin360Popper = action.payload;
    },
    setShowGuest360Popper: (state, action) => {
      state.showGuest360Popper = action.payload;
    },
    setShowSignup360Popper: (state, action) => {
      state.showSignup360Popper = action.payload;
    },
    setShowNotLoginPopper: (state, action) => {
      state.showNotLoginPopper = action.payload;
    },
    setShowSignupPopper: (state, action) => {
      state.showSignupPopper = action.payload;
    },
    setGuestID: (state, action) => {
      state.guestId = action.payload;
    },
    setShowOrganizationPopper: (state, action) => {
      state.showOrganizationPopper = action.payload;
    },
    setShowProfilePopper: (state, action) => {
      state.showProfilePopper = action.payload;
    },
    setShowOrgModal: (state, action) => {
      state.showOrgModal = action.payload;
    },
    setCurrentUserData: (state, action) => {
      state.currentUser = action.payload;
    },
    setShowUserVerifyStatusModal: (state, action) => {
      state.showUserVerifyStatusModal = action.payload;
    },
    setShowGuestSignupModal: (state, action) => {
      state.showGuestSignupModal = action.payload;
    },
    setShowLoginModal: (state, action) => {
      state.showLoginModal = action.payload;
    },
    setShowSignupModal: (state, action) => {
      state.showSignupModal = action.payload;
    },
    setIsOnAssetPage: (state, action) => {
      state.isOnAssetPage = action.payload;
    },
    setIsShowTNCDialog: (state, action) => {
      state.isShowTNCDialog = action.payload;
    },
    setLoginAction: (state, action) => {
      state.loginAction = action.payload;
    },
  },
});
